import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blog/[slug]/BlogPost.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ShareButtons.tsx");
